import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IonicModule } from '@ionic/angular/lazy';
import { AffiliatePickerPage } from 'src/app/modals/affiliate-picker/affiliate-picker.page';

const routes: Routes = [
  {
    path: '',
    component: AffiliatePickerPage
  }
];

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    FontAwesomeModule,
    RouterModule.forChild(routes)
  ],
  declarations: [AffiliatePickerPage]
})
export class AffiliatePickerPageModule {}
